import React from 'react';
import Avatar from '@atlaskit/avatar';
import GroupContainer from '../container/index.tsx';
import type { Props } from './types.tsx';

function Team({ height, width, position, team }: Props) {
	return (
		<GroupContainer
			{...{ height, width, position }}
			title={team.title}
			tooltipKey={team.id}
			testId={`portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.team-group-${team.id}`}
			iconBefore={<Avatar size="small" src={team.avatarUrl} />}
		/>
	);
}

export default Team;
